import API_BASE_URL from "../config";
import axios from "axios";
import FleetVehicleSelect from "../VehicleManagement/FleetVehicleSelect";
import React, { useState } from "react";

const DriverDeduction = () => {
  const [formData, setFormData] = useState({
    date: "",
    driverId: "",
    driverName: "",
    driverMobile: "",
    vehicleNumber: "",
    lossType: "",
    location: "",
    description: "",
    amount: "",
    recoveryStatus: "",
    remarks: "",
  });
  const [showConfirmation, setShowConfirmation] = useState(false);

  const driverData = {
    D001: { name: "John Doe", mobile: "9876543210" },
    D002: { name: "Jane Smith", mobile: "9123456789" },
    D003: { name: "Michael Johnson", mobile: "9988776655" },
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "driverId") {
      setFormData({
        ...formData,
        driverId: value,
        driverName: driverData[value]?.name || "",
        driverMobile: driverData[value]?.mobile || "",
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleClear = () => {
    setFormData({
      date: "", driverId: "", driverName: "", driverMobile: "",
      vehicleNumber: "", lossType: "", location: "", description: "",
      amount: "", recoveryStatus: "", remarks: "",
    });
  };

  const handleContinue = () => setShowConfirmation(true);
  const handleBack = () => setShowConfirmation(false);
  const [submitting, setSubmitting] = React.useState(false);
  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await axios.post(API_BASE_URL + "/driver/deductions", formData);
      alert("Deduction details submitted successfully!");
      handleClear();
    } catch (error) {
      console.error("Error submitting deduction:", error);
      alert("Error: " + (error?.response?.data?.message || error.message || "Failed to submit. Please try again."));
    } finally {
      setSubmitting(false);
    }
  };

  const s = {
    container: {
      fontFamily: "Arial, sans-serif",
      marginLeft: "278px",
      marginRight: "10px",
      backgroundColor: "#ffffff",
      color: "#000000",
      minHeight: "100vh",
    },
    pageHeader: {
      backgroundColor: "#FFC107",
      padding: "16px 24px",
      marginBottom: "0px",
    },
    pageHeaderText: {
      fontSize: "22px",
      fontWeight: "700",
      color: "#000000",
      letterSpacing: "1px",
      textTransform: "uppercase",
      margin: 0,
    },
    contentBody: {
      padding: "24px",
    },
    sectionTitle: {
      fontSize: "15px",
      fontWeight: "700",
      color: "#000000",
      marginBottom: "4px",
    },
    sectionDivider: {
      border: "none",
      borderTop: "2px solid #FFC107",
      marginBottom: "16px",
    },
    formGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "16px",
      marginBottom: "24px",
    },
    fieldGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    label: {
      fontSize: "13px",
      fontWeight: "700",
      color: "#000000",
    },
    input: {
      width: "100%",
      padding: "8px 10px",
      border: "1.5px solid #000000",
      borderRadius: "0",
      fontSize: "13px",
      backgroundColor: "#ffffff",
      color: "#000000",
      outline: "none",
      boxSizing: "border-box",
    },
    inputReadOnly: {
      width: "100%",
      padding: "8px 10px",
      border: "1.5px solid #000000",
      borderRadius: "0",
      fontSize: "13px",
      backgroundColor: "#f5f5f5",
      color: "#000000",
      outline: "none",
      boxSizing: "border-box",
      cursor: "not-allowed",
    },
    textarea: {
      width: "100%",
      padding: "8px 10px",
      border: "1.5px solid #000000",
      borderRadius: "0",
      fontSize: "13px",
      backgroundColor: "#ffffff",
      color: "#000000",
      outline: "none",
      boxSizing: "border-box",
      minHeight: "80px",
      resize: "vertical",
    },
    textareaReadOnly: {
      width: "100%",
      padding: "8px 10px",
      border: "1.5px solid #000000",
      borderRadius: "0",
      fontSize: "13px",
      backgroundColor: "#f5f5f5",
      color: "#000000",
      outline: "none",
      boxSizing: "border-box",
      minHeight: "80px",
      resize: "vertical",
      cursor: "not-allowed",
    },
    select: {
      width: "100%",
      padding: "8px 10px",
      border: "1.5px solid #000000",
      borderRadius: "0",
      fontSize: "13px",
      backgroundColor: "#ffffff",
      color: "#000000",
      outline: "none",
      boxSizing: "border-box",
      cursor: "pointer",
    },
    selectReadOnly: {
      width: "100%",
      padding: "8px 10px",
      border: "1.5px solid #000000",
      borderRadius: "0",
      fontSize: "13px",
      backgroundColor: "#f5f5f5",
      color: "#000000",
      outline: "none",
      boxSizing: "border-box",
      cursor: "not-allowed",
    },
    buttonRow: {
      display: "flex",
      gap: "12px",
      marginTop: "8px",
    },
    primaryButton: {
      padding: "8px 28px",
      backgroundColor: "#FFC107",
      color: "#000000",
      border: "none",
      borderRadius: "0",
      cursor: "pointer",
      fontWeight: "700",
      fontSize: "13px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    secondaryButton: {
      padding: "8px 28px",
      backgroundColor: "#000000",
      color: "#ffffff",
      border: "none",
      borderRadius: "0",
      cursor: "pointer",
      fontWeight: "700",
      fontSize: "13px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
  };

  return (
    <div style={s.container}>
      {/* Yellow header bar */}
      <div style={s.pageHeader}>
        <h1 style={s.pageHeaderText}>
          {showConfirmation ? "Driver Deductions — Confirm" : "Driver Deductions"}
        </h1>
      </div>

      <div style={s.contentBody}>
        <div style={s.sectionTitle}>
          {showConfirmation ? "Confirm Deduction Details" : "Deduction Management"}
        </div>
        <hr style={s.sectionDivider} />

        {showConfirmation ? (
          <>
            <div style={s.formGrid}>
              <div style={s.fieldGroup}>
                <label style={s.label}>Date:</label>
                <input style={s.inputReadOnly} type="date" value={formData.date} readOnly />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Driver ID:</label>
                <input style={s.inputReadOnly} type="text" value={formData.driverId} readOnly />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Driver Name:</label>
                <input style={s.inputReadOnly} type="text" value={formData.driverName} readOnly />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Driver Mobile Number:</label>
                <input style={s.inputReadOnly} type="text" value={formData.driverMobile} readOnly />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Vehicle Number:</label>
                <input style={s.inputReadOnly} type="text" value={formData.vehicleNumber} readOnly />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Loss Type:</label>
                <select style={s.selectReadOnly} value={formData.lossType} disabled>
                  <option value="Accident">Accident</option>
                  <option value="Damage">Damage</option>
                  <option value="Fines">Fines</option>
                  <option value="Diesel Empty">Diesel Empty</option>
                </select>
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Location:</label>
                <input style={s.inputReadOnly} type="text" value={formData.location} readOnly />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Description:</label>
                <textarea style={s.textareaReadOnly} value={formData.description} readOnly />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Amount:</label>
                <input style={s.inputReadOnly} type="number" value={formData.amount} readOnly />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Recovery Status:</label>
                <select style={s.selectReadOnly} value={formData.recoveryStatus} disabled>
                  <option value="Recovered">Recovered</option>
                  <option value="Not Recovered">Not Recovered</option>
                </select>
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Remarks:</label>
                <textarea style={s.textareaReadOnly} value={formData.remarks} readOnly />
              </div>
            </div>
            <div style={s.buttonRow}>
              <button onClick={handleBack} style={s.secondaryButton}>Back</button>
              <button onClick={handleSubmit} style={{...s.primaryButton, opacity: submitting ? 0.7 : 1}} disabled={submitting}>{submitting ? "Saving..." : "Submit"}</button>
            </div>
          </>
        ) : (
          <>
            <div style={s.formGrid}>
              <div style={s.fieldGroup}>
                <label style={s.label}>Date:</label>
                <input style={s.input} type="date" name="date" value={formData.date} onChange={handleChange} required />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Driver ID:</label>
                <input style={s.input} type="text" name="driverId" value={formData.driverId} onChange={handleChange} required />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Driver Name:</label>
                <input style={s.inputReadOnly} type="text" name="driverName" value={formData.driverName} readOnly />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Driver Mobile Number:</label>
                <input style={s.inputReadOnly} type="text" name="driverMobile" value={formData.driverMobile} readOnly />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Vehicle Number:</label>
                <FleetVehicleSelect
                  name="vehicleNumber"
                  value={formData.vehicleNumber}
                  onChange={handleChange}
                  style={s.input}
                  required
                />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Loss Type:</label>
                <select style={s.select} name="lossType" value={formData.lossType} onChange={handleChange} required>
                  <option value="">Select</option>
                  <option value="Accident">Accident</option>
                  <option value="Damage">Damage</option>
                  <option value="Fines">Fines</option>
                  <option value="Diesel Empty">Diesel Empty</option>
                </select>
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Location:</label>
                <input style={s.input} type="text" name="location" value={formData.location} onChange={handleChange} required />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Description:</label>
                <textarea style={s.textarea} name="description" value={formData.description} onChange={handleChange} required />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Amount:</label>
                <input style={s.input} type="number" name="amount" value={formData.amount} onChange={handleChange} required />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Recovery Status:</label>
                <select style={s.select} name="recoveryStatus" value={formData.recoveryStatus} onChange={handleChange} required>
                  <option value="">Select</option>
                  <option value="Recovered">Recovered</option>
                  <option value="Not Recovered">Not Recovered</option>
                </select>
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Remarks:</label>
                <textarea style={s.textarea} name="remarks" value={formData.remarks} onChange={handleChange} required />
              </div>
            </div>
            <div style={s.buttonRow}>
              <button onClick={handleClear} style={s.secondaryButton}>Clear</button>
              <button onClick={handleContinue} style={s.primaryButton}>Continue</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DriverDeduction;